export const ForgotUsernameResources = {
  ForgotUsernameHeader: "Let's find your account",
  ForgotUsernameDescription: "Enter the information below. We'll send your username or a verification code to the email address on file.",
  NewUserHeader: "Set up your online account",
  NewUserDescription: "<div class='mb-3'>Enter your information to access your account. The details you provide need to match the information your employer used to enroll you in your benefit account.</div><div>If you're unsure what information was provided by your employer, please contact your HR department for assistance.</div>"
};
